/**
 * Security Patch para CVE-2024-6783 e CVE-2024-9506
 * 
 * Este módulo corrige as vulnerabilidades:
 * - CVE-2024-6783: XSS via prototype pollution
 * - CVE-2024-9506: ReDoS no parseHTML
 * 
 * Aplicado automaticamente ao carregar a aplicação
 */

// Proteção contra prototype pollution
const DANGEROUS_KEYS = ['__proto__', 'constructor', 'prototype'];

function isPrototypePolluted(key) {
  return DANGEROUS_KEYS.includes(key);
}

// Limpar propriedades perigosas do Object.prototype (sem congelar)
try {
  const objectPrototypeProps = ['staticClass', 'staticStyle', 'class', 'style'];
  objectPrototypeProps.forEach(prop => {
    if (Object.prototype.hasOwnProperty(prop)) {
      delete Object.prototype[prop];
    }
  });
  
  // Prevenir adição de __proto__, constructor, prototype
  DANGEROUS_KEYS.forEach(key => {
    if (Object.prototype.hasOwnProperty(key) && key !== 'constructor') {
      try {
        delete Object.prototype[key];
      } catch (e) {
        // Ignorar se não puder deletar
      }
    }
  });
} catch (e) {
  // Silencioso
}

// Proteção contra ReDoS - Limite de tamanho de template
const MAX_TEMPLATE_SIZE = 500000; // 500KB

// Interceptar Vue.compile se disponível
if (typeof window !== 'undefined' && window.Vue) {
  const originalCompile = window.Vue.compile;
  
  if (originalCompile) {
    window.Vue.compile = function(template) {
      if (typeof template === 'string' && template.length > MAX_TEMPLATE_SIZE) {
        template = template.substring(0, MAX_TEMPLATE_SIZE);
      }
      return originalCompile.call(this, template);
    };
  }
}

// Validar propriedades de componentes
function validateComponentProps(props) {
  if (!props || typeof props !== 'object') return props;
  
  const cleaned = {};
  for (const key in props) {
    if (props.hasOwnProperty(key) && !isPrototypePolluted(key)) {
      cleaned[key] = props[key];
    }
  }
  return cleaned;
}

// Proteção adicional: Sanitizar atributos HTML perigosos
function sanitizeAttributes(attrs) {
  if (!attrs || typeof attrs !== 'object') return attrs;
  
  const sanitized = {};
  for (const key in attrs) {
    if (attrs.hasOwnProperty(key)) {
      // Bloquear atributos que começam com 'on' (event handlers inline)
      if (key.startsWith('on') && key.length > 2) {
        continue;
      }
      
      // Bloquear __proto__ e similares
      if (isPrototypePolluted(key)) {
        continue;
      }
      
      sanitized[key] = attrs[key];
    }
  }
  return sanitized;
}

// Proteção mais segura - não sobrescrever funções nativas
// Apenas congelar prototypes e validar em pontos específicos

// Wrapper seguro para Object.assign
const safeAssign = function(target, ...sources) {
  sources.forEach(source => {
    if (source && typeof source === 'object') {
      for (const key in source) {
        if (source.hasOwnProperty(key) && !isPrototypePolluted(key)) {
          target[key] = source[key];
        }
      }
    }
  });
  return target;
};

// Exportar função segura como alternativa
if (typeof window !== 'undefined') {
  window.safeAssign = safeAssign;
}

// Exportar funções utilitárias
export {
  isPrototypePolluted,
  validateComponentProps,
  sanitizeAttributes
};
